// extracted by mini-css-extract-plugin
export default {"root":"Deals_root__GrkCT"};